import { FC, useEffect, useState } from 'react';

import { NavigationItem } from '@telialt/models/src/Navigation';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { UPSELL_OFFER_URL_STORAGE_KEY } from '../../constants';
import { MobileMenuItemLink } from '../MobileMenu/MobileMenuItemLink';
import { MobileMenuItemComponentSkeleton } from './MobileMenuItemComponentSkeleton';

type Props = {
    item: NavigationItem;
    menuLevel: number;
};

export const MobileMenuItemComponentUpsell: FC<Props> = ({ item, menuLevel }) => {
    const [isMounted, setIsMounted] = useState(false);
    const segment = useSegment();

    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) {
        return <MobileMenuItemComponentSkeleton />;
    }

    const upSellOfferUrl = window.localStorage.getItem(UPSELL_OFFER_URL_STORAGE_KEY);

    if (segment !== TeliaSegment.B2b || !upSellOfferUrl) {
        return null;
    }

    return <MobileMenuItemLink item={{ ...item, url: upSellOfferUrl }} menuLevel={menuLevel} />;
};
